// MACHINERY V2 (Stroje) — right-cluster language menu (M2.1; split out of
// ChromeRightMenus.tsx at M2.2 for the 300-line cap).
//
// Behaviour is the live app's, unchanged: mirrors LanguageSwitcher.tsx
// (i18n.changeLanguage + best-effort customersApi.updateLanguage). That switch
// moved to useChromeActions.ts at M2.16a — VERBATIM — because the phone drawer
// offers the same one and the silent-persist-failure story must not exist twice.
// The CODE and NAME tables moved with it at the fix pass, for the same reason
// and one more: the drawer's fork of them was typed `Record<string, string>`,
// so a fourth language would have compiled there and printed a raw code.
// The portal rule lives in chromeMenuContent.tsx.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import React from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";

import useTranslation, { SupportedLanguage } from "../../../../shared/hooks/useTranslation";
import { MenuContent } from "./chromeMenuContent";
import { LANG_CODES, LANG_NAMES, useChromeLanguage } from "./useChromeActions";

/** "SK ▾" trigger + language menu. */
export const ChromeLangMenu: React.FC = () => {
  const { translate } = useTranslation(["layout", "common"]);
  const { current, languages, select } = useChromeLanguage();

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          aria-label={translate("layout:chromeV4.language")}
          style={{
            border: 0,
            background: "transparent",
            padding: "4px 2px",
            cursor: "pointer",
            fontFamily: "var(--font-mono)",
            fontSize: 11.5,
            color: "var(--ink-2)",
            whiteSpace: "nowrap",
          }}
        >
          {LANG_CODES[current] || LANG_CODES.sk} ▾
        </button>
      </DropdownMenu.Trigger>
      <MenuContent width={188}>
        {languages.map((lng: SupportedLanguage) => (
          <DropdownMenu.Item
            key={lng}
            className="mi"
            onSelect={() => select(lng)}
            style={{
              fontWeight: lng === current ? 600 : 400,
              color: lng === current ? "var(--accent)" : undefined,
            }}
          >
            <span
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: 9.5,
                letterSpacing: "0.05em",
                width: 20,
                flexShrink: 0,
                color: "var(--muted)",
              }}
            >
              {LANG_CODES[lng]}
            </span>
            {LANG_NAMES[lng]}
            <span style={{ flex: 1 }} />
            {lng === current && <span style={{ color: "var(--accent)", fontSize: 12 }}>✓</span>}
          </DropdownMenu.Item>
        ))}
      </MenuContent>
    </DropdownMenu.Root>
  );
};
export default ChromeLangMenu;
